import { Outlet } from "react-router-dom";

const Attenadancelayout = () => {
  return (
    <>
      <Outlet />
    </>
  );
};

export default Attenadancelayout;
